import * as React from "react";
import { expr } from "./expr";
import { isPlainObject } from "./isPlainObject";
import { mapReduce } from "./mapReduce";
export function isExpression(value) {
    return typeof value === "function" && value["$$Expression"] === true;
}
export function isPureFunction(value) {
    return typeof value === "function" && !isExpression(value);
}
export function makeExpressionObservable(props) {
    var ignore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(_) {
        return false;
    }, seen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new WeakMap();
    if (React.isValidElement(props)) return props;
    if (isPureFunction(props)) return props;
    if (isExpression(props)) return expr(props);
    if (Array.isArray(props)) return props.map(function(prop) {
        return makeExpressionObservable(prop, ignore, seen);
    });
    if (isPlainObject(props)) {
        if (seen.has(props)) return seen.get(props); // 如果已经处理过，直接返回结果
        // 标记为已处理
        var shadow = Object.create(Object.getPrototypeOf(props));
        seen.set(props, shadow);
        return mapReduce(Object.keys(props), function(key) {
            return ignore(key) ? props[key] : makeExpressionObservable(props[key], ignore, seen);
        }, shadow);
    }
    return props;
}
